function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "16",
  height: "12",
  viewBox: "0 0 16 12",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M.8 1.6A.8.8 0 11.8 0h14.4a.8.8 0 110 1.6H.8zm14.4 8a.8.8 0 110 1.6H.8a.8.8 0 110-1.6h14.4zm0-4.8a.8.8 0 110 1.6H.8a.8.8 0 110-1.6h14.4z",
  fill: "currentColor",
  fillRule: "evenodd"
})));